/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { AttendeeQuestionChoiceListItem } from './attendee_question_choice_list_item';
import * as Constants from '../constants';
import { SortableListContainer as SortableList } from '../../../admin/react/sortable_list.jsx';
import { SortableItemContainer as SortableItem } from '../../../admin/react/sortable_item.jsx';

export class AttendeeQuestionChoiceList extends React.Component {
        static initClass() {
          this.propTypes = {
            onAdd: PropTypes.func,
            onChange: PropTypes.func,
            onDelete: PropTypes.func,
            onDragStart: PropTypes.func,
            onDragUpdate: PropTypes.func,
            onDragFinish: PropTypes.func,
            onDragCancel: PropTypes.func,
            choices: PropTypes.array
          };
        }


        constructor(props) {
          super(props);
          this.onDragStart = this.onDragStart.bind(this);
          this.onDragFinish = this.onDragFinish.bind(this);
          this.onDragCancel = this.onDragCancel.bind(this);
          this.renderResponseChoices = this.renderResponseChoices.bind(this);
          this.onClick = this.onClick.bind(this);
this.render = this.render.bind(this);

          // Make up an identifier for this question, to prevent drags of choices *between* questions
          this._listIdentifier = `${Constants.DRAG_TYPE_ATTENDEE_QUESTION_CHOICE  }:${  props.questionId}`;
          this.state =
            {currentlyDragging: false};
        }

        // Wrap the drag start/finish callbacks to store the state of what's currently being dragged
        onDragStart(item) {
          this.setState({currentlyDragging: item.id});
          return (typeof this.props.onDragStart === 'function' ? this.props.onDragStart(item) : undefined);
        }

        onDragFinish(result, item) {
          this.setState({currentlyDragging: false});
          return (typeof this.props.onDragFinish === 'function' ? this.props.onDragFinish(result, item) : undefined);
        }

        onDragCancel(item) {
          this.setState({currentlyDragging: false});
          return (typeof this.props.onDragCancel === 'function' ? this.props.onDragCancel(item) : undefined);
        }

        renderResponseChoices() {
          let choice_items;
          const my = this;

          return choice_items = Array.from(this.props.choices).map((choice, index) =>
            <SortableItem key={index}
                            index={index}
                            dragItemId={choice}
                            itemIsDragSource={false}
                            dragging={this.state.currentlyDragging === choice}
                            listIdentifier={this._listIdentifier}
                            onDragStart={my.onDragStart}
                            onDragUpdate={my.props.onDragUpdate}
                            onDragFinish={my.onDragFinish}
                            onDragCancel={my.onDragCancel}>
                <AttendeeQuestionChoiceListItem label={`Option ${  index + 1}`}
                                                value={choice}
                                                onChange={this.props.onChange.bind(this, index)}
                                                onDelete={this.props.onDelete.bind(this, index)}/>
              </SortableItem>);
        }


        onClick(event) {
          event.preventDefault();
          return (typeof this.props.onAdd === 'function' ? this.props.onAdd(event) : undefined);
        }

        render() {
          return <div className="attendee-question-choices">
            <SortableList listIdentifier={this._listIdentifier}>
              {this.renderResponseChoices()}
              <li className="attendee-question-choice attendee-question-choice--add">
                <div className="attendee-question-choice--label">
                </div>
                <a  className="add-attendee-question-choice"
                    href="#"
                    onClick={this.onClick}>+ Add another option</a>
              </li>
            </SortableList>
          </div>;
        }
      }
AttendeeQuestionChoiceList.initClass();
